import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="bg-white shadow-md py-4 px-8 flex justify-between items-center">
      <h1 className="text-2xl font-bold text-indigo-600">MyApp</h1>
      <nav className="space-x-6">
        <Link to="/" className="text-gray-700 hover:text-indigo-600">
          Home
        </Link>
        <Link to="/product" className="text-gray-700 hover:text-indigo-600">
          Product
        </Link>
        <Link to="/help" className="text-gray-700 hover:text-indigo-600">
          Help
        </Link>
        <Link to="/contact" className="text-gray-700 hover:text-indigo-600">
          Contact
        </Link>
      </nav>
    </header>
  );
};

export default Header;